import { render } from "./PopupBtn1.vue?vue&type=template&id=1bb1bbeb&scoped=true"
import script from "./PopupBtn1.vue?vue&type=script&lang=js"
export * from "./PopupBtn1.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=1bb1bbeb&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb1bbeb"]])

export default __exports__